export default function useBeforeFirstRender(f) {
    const [hasRendered, setHasRendered] = React.useState(false)

    React.useEffect(() => setHasRendered(true), [])

    if (!hasRendered) {
        f()
    }
}
